import { batch } from 'react-redux';

// project imports
import gestopAPI from 'utils/gestopAPI';
import { dispatch } from 'store/index';
import { errorProcessor } from 'utils/processors';
import { businessOpportunityTypeActions } from './slice';
import capabilities from './capabilities';
import createImportApi from 'utils/importAPI';

const businessOpportunityTypeImportApi = createImportApi({
    actions: businessOpportunityTypeActions,
    capabilities,
    endpoint: 'workmgmt/businessopportunitytypes',
    templateFileName: 'BusinessOpportunityTypeImportTpl'
});
export const ApiBusinessOpportunityTypesImportCollection = businessOpportunityTypeImportApi.importCollection;
export const ApiBusinessOpportunityTypesDownloadImportModelItem = businessOpportunityTypeImportApi.downloadImportModel;

export const ApiBusinessOpportunityTypesGetCollection = async ({
    filters = [],
    orderBy = [],
    groupBy = [],
    page = 1,
    limit = 10,
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (updateStore && capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/businessopportunitytypes/list', { filters, orderBy, groupBy, page, limit, includeSafeDeleted }, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.setList(response?.data?.list));
                    dispatch(businessOpportunityTypeActions.setCount(response?.data?.count));
                }
                if (updateStore && capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data?.list);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (updateStore && capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesCountCollection = async ({
    filters = [],
    includeSafeDeleted = false,
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    await gestopAPI
        .post('workmgmt/businessopportunitytypes/count', { filters, includeSafeDeleted }, config)
        .then((response) => {
            if (typeof successCallback === 'function') {
                successCallback(response?.data?.count);
            }
        })
        .catch((error) => {
            const errorMsg = errorProcessor(error?.response?.data);

            if (typeof errorCallback === 'function') {
                errorCallback(errorMsg);
            }
        });
};

export const ApiBusinessOpportunityTypesPostCollection = async ({
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/businessopportunitytypes', data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.insertItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesDeleteCollection = async ({
    ids = [],
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .post('workmgmt/businessopportunitytypes/safedelete', ids, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.deleteItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesExportCollection = async ({
    exportType = 'allRows',
    format = 'pdf',
    columns = [],
    filters = [],
    orderBy = [],
    groupBy = [],
    successCallback = () => {},
    errorCallback = () => {},
    config = {}
}) => {
    if (capabilities.app.includes('exporter')) {
        dispatch(businessOpportunityTypeActions.startExporting());
    }

    await gestopAPI
        .post(
            'workmgmt/businessopportunitytypes/export',
            { exportType, format, columns, filters, orderBy, groupBy },
            { ...config, responseType: 'blob' }
        )
        .then((response) =>
            batch(() => {
                window.open(URL.createObjectURL(response?.data));

                if (capabilities.app.includes('exporter')) {
                    dispatch(businessOpportunityTypeActions.stopExporting());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('exporter')) {
                    dispatch(businessOpportunityTypeActions.stopExporting());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesPutItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .put(`workmgmt/businessopportunitytypes/${id}`, data, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesPatchItem = async ({
    id,
    data = {},
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .patch(`workmgmt/businessopportunitytypes/${id}`, data, {
            ...config,
            headers: { ...config?.headers, 'Content-Type': 'application/merge-patch+json' } // Specific content type for PATCH requests
        })
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.updateItems(response?.data));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesDeleteItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunitytypes/safedelete/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesRestoreDeletedItem = async ({
    id,
    successCallback = () => {},
    errorCallback = () => {},
    updateStore = true,
    config = {}
}) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .post(`workmgmt/businessopportunitytypes/restoresafedeleted/${id}`, {}, config)
        .then((response) =>
            batch(() => {
                if (updateStore) {
                    dispatch(businessOpportunityTypeActions.deleteItems(id));
                }
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};

export const ApiBusinessOpportunityTypesGetItem = async ({ id, successCallback = () => {}, errorCallback = () => {}, config = {} }) => {
    if (capabilities.app.includes('loader')) {
        dispatch(businessOpportunityTypeActions.startLoading());
    }

    await gestopAPI
        .get(`workmgmt/businessopportunitytypes/${id}`, config)
        .then((response) =>
            batch(() => {
                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (typeof successCallback === 'function') {
                    successCallback(response?.data);
                }
            })
        )
        .catch((error) =>
            batch(() => {
                const errorMsg = errorProcessor(error?.response?.data);

                if (capabilities.app.includes('loader')) {
                    dispatch(businessOpportunityTypeActions.stopLoading());
                }
                if (capabilities.app.includes('error-logger')) {
                    dispatch(businessOpportunityTypeActions.logError(errorMsg));
                }
                if (typeof errorCallback === 'function') {
                    errorCallback(errorMsg);
                }
            })
        );
};
